import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";
import Modal from "./Modal";
import Moment from "react-moment";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class ScheduledSessions extends PureComponent {
  static propTypes = {
    removeSession: PropTypes.func.isRequired,
    addSession: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    showResolveConflictModal: PropTypes.func.isRequired,
    changeDay: PropTypes.func.isRequired,
    mobile: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedPresentationId: null,
      showRemoveLinkedSessionsModal: false,
      accordionExpanded: {},
    };
  }

  componentDidMount = () => {
    let accordionExpanded = {};
    this.props.schedule.registeredPresentations.forEach((presentation) => {
      accordionExpanded[presentation.id] = false;
    });

    this.setState({ accordionExpanded });
  };

  _toggleDetails = (id) => {
    let { accordionExpanded } = this.state;
    let newAccordionExpanded = {};
    this.props.schedule.registeredPresentations.forEach((presentation) => {
      if (presentation.id === id) {
        newAccordionExpanded[presentation.id] = !accordionExpanded[
          presentation.id
        ];
      } else {
        newAccordionExpanded[presentation.id] =
          accordionExpanded[presentation.id];
      }
    });

    this.setState({ accordionExpanded: newAccordionExpanded });
  };

  _changeSelectedPresentation = (e) => {
    this.setState({ selectedPresentationId: parseInt(e.target.value) });
  };

  _hideRemoveLinkedSessionsModal = () => {
    this.setState({ showRemoveLinkedSessionsModal: false });
  };

  _removeSession = (id, e) => {
    e.stopPropagation();

    let presentation = this.props.schedule.registeredPresentations.find(
      (p) => p.id === parseInt(id)
    );
    if (presentation.presentationGroups.length > 0) {
      this.setState({
        selectedPresentationId: parseInt(id),
        showRemoveLinkedSessionsModal: true,
      });
    } else {
      this.props.removeSession(id, e);
    }
  };

  _confirmRemoveLinkedSessions = (e) => {
    this.props.removeSession(this.state.selectedPresentationId, e);
    this.setState({
      selectedPresentationId: null,
      showRemoveLinkedSessionsModal: false,
    });
  };

  _getDotClass = (specialty) => {
    return (
      "dot " +
      specialty
        .trim()
        .replace(/[^a-z0-9]|\s+|\r?\n|\r/gim, "-")
        .toLowerCase()
    );
  };

  _removeSessionButtonText = (presentation) => {
    if (presentation.isWaitlist && !presentation.paid) {
      return "Remove from Waitlist";
    } else if (presentation.isNotify && presentation.isFull) {
      return "Remove Notify Me";
    } else {
      return "Remove";
    }
  };

  _removeLinkedPresentationsModal = () => {
    return (
      <Modal
        show={this.state.showRemoveLinkedSessionsModal}
        onClose={this._hideRemoveLinkedSessionsModal}
      >
        <h2 className="linked">Linked Sessions</h2>
        <p>
          The session you have selected is linked to other sessions on your
          schedule. Removing this session will remove all linked sessions.
        </p>
        <p>Would you like to remove the selected session?</p>
        <div className="row mt-4">
          <div className="col-md-6">
            <button
              className="btn btn-primary btn-block"
              disabled={!this.state.selectedPresentationId}
              onClick={(e) => this._confirmRemoveLinkedSessions(e)}
            >
              Remove Sessions
            </button>
          </div>
          <div className="col-md-6">
            <button
              className="btn btn-secondary btn-block"
              disabled={!this.state.selectedPresentationId}
              onClick={this._hideRemoveLinkedSessionsModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  _viewAvailableSessions = (day) => {
    this.props.changeDay(day);
  };

  render() {
    let { schedule } = this.props;
    let registeredPresentations = schedule.registeredPresentations.filter(
      (rp) => (!rp.isWaitlist && !rp.isNotify) || rp.paid
    );

    return (
      <div className="scheduled-sessions">
        {schedule.days.map((day, index) => (
          <div className="row" key={index}>
            <div className="col-12">
              <div className="schedule-date">
                <Moment format="dddd (M/D)">{day}</Moment>
              </div>
              <div className="session-list">
                {registeredPresentations
                  .filter(
                    (presentation) => presentation.presentationDate === day
                  )
                  .map((session, index) => (
                    <Accordion allowZeroExpanded
                      key={session.id}
                      className={
                        "session-item " +
                        (session.conflictingPresentationIds.length > 0
                          ? "has-conflict"
                          : "")
                      }
                    >
                      <AccordionItem
                        expanded={this.state.accordionExpanded[session.id]}
                      >
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <div
                              onClick={(e) => this._toggleDetails(session.id)}
                              className="clickable"
                            >
                              <div className="row header">
                                <div className="col-lg-9 pl-1 pl-lg-4">
                                  <div className="arrow right ml-1 d-none d-lg-inline-block" />
                                  <span className="text-bold d-none d-lg-inline-block pl-3">
                                    {session.titleShortName}
                                  </span>
                                  <div className="text-bold d-lg-none pl-2 pr-3">
                                    {session.titleShortName}
                                  </div>
                                </div>
                                <div className="col-md-3 d-none d-lg-flex justify-content-end">
                                  {session.conflictingPresentationIds.length >
                                    0 && (
                                      <button
                                        className="btn btn-resolve-conflict"
                                        onClick={(e) =>
                                          this.props.showResolveConflictModal(
                                            session.id,
                                            e
                                          )
                                        }
                                      >
                                        Resolve Conflict
                                      </button>
                                    )}
                                  {session.conflictingPresentationIds.length ===
                                    0 && (
                                      <button
                                        className="btn btn-remove-session"
                                        onClick={(e) =>
                                          this._removeSession(session.id, e)
                                        }
                                      >
                                        {this._removeSessionButtonText(session)}
                                      </button>
                                    )}
                                </div>
                              </div>
                              <div className="row pl-3 pl-lg-5 presentation-time">
                                <div className="col-md-6 pl-2">
                                  <span>
                                    <Moment format="h:mm A">
                                      {session.startTime}
                                    </Moment>{" "}
                                    -{" "}
                                    <Moment format="h:mm A">
                                      {session.endTime}
                                    </Moment>
                                    {session.presentationFee > 0 && (
                                      <span>
                                        <span> : </span>
                                        <span className="fee">
                                          ${session.presentationFee.toFixed(2)}{" "}
                                          Fee
                                        </span>
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading >
                        <AccordionItemPanel>
                          <div className="row pl-5 pt-3 session-row">
                            <div className="col-md-9 pl-2 session-details">
                              <div className="row mb-1">
                                <div className="col-lg-3 col-4">Date :</div>
                                <div className="col-lg-9 col-8">
                                  <Moment format="dddd (M/D)">
                                    {session.presentationDate}
                                  </Moment>
                                </div>
                              </div>
                              <div className="row mb-1">
                                <div className="col-lg-3 col-4">Time :</div>
                                <div className="col-lg-9 col-8">
                                  <Moment format="h:mm A">
                                    {session.startTime}
                                  </Moment>
                                </div>
                              </div>
                              {session.levelDisplayText && (
                                <div className="row mb-1">
                                  <div className="col-lg-3 col-4">
                                    Content Level :
                                  </div>
                                  <div className="col-lg-9 col-8">
                                    {session.levelDisplayText}
                                  </div>
                                </div>
                              )}
                              {session.speakerListing && (
                                <div className="row mb-1 speakers d-lg-none">
                                  <div className="col-lg-3 col-4">
                                    Speaker(s) :
                                  </div>
                                  <div className="col-lg-9 col-8">
                                    {session.speakerListing}
                                  </div>
                                </div>
                              )}
                              <div className="row mb-1">
                                <div className="col-lg-3 col-4">CE Hours :</div>
                                <div className="col-lg-9 col-8">
                                  {session.contactHours}
                                </div>
                              </div>
                              {session.therapeuticAreas.length > 0 && (
                                <div className="row mb-1 mt-1">
                                  <div className="col-lg-3 col-4 mt-1">
                                    Subjects :
                                  </div>
                                  <div className="col-lg-9 col-8">
                                    {session.therapeuticAreas.map(
                                      (t, index) => (
                                        <span
                                          className="therapeutic-area"
                                          key={index}
                                        >
                                          {t.name}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                              <div className="row pl-lg-3 pl-0 pr-3 pt-3 pb-2">
                                <div
                                  className="presentation-description"
                                  dangerouslySetInnerHTML={{
                                    __html: session.description,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 text-left d-none d-lg-block">
                              {session.speakerListing && (
                                <div className="speakers">
                                  <div>Speaker(s):</div>
                                  <div>{session.speakerListing}</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </AccordionItemPanel>
                        <div className="row d-lg-none mb-2">
                          <div className="col-12">
                            <button
                              className="float-right mr-4 link-button"
                              onClick={(e) => this._toggleDetails(session.id)}
                            >
                              {this.state.accordionExpanded[session.id]
                                ? "See Less Info"
                                : "See More Info"}
                            </button>
                          </div>
                        </div>
                        <div className="row d-lg-none mt-3 mb-2">
                          <div className="col-10 col-centered">
                            {session.conflictingPresentationIds.length > 0 && (
                              <button
                                className="btn btn-resolve-conflict"
                                onClick={(e) =>
                                  this.props.showResolveConflictModal(
                                    session.id,
                                    e
                                  )
                                }
                              >
                                Resolve Conflict
                              </button>
                            )}
                            {session.conflictingPresentationIds.length ===
                              0 && (
                                <button
                                  className="btn btn-remove-session"
                                  onClick={(e) =>
                                    this._removeSession(session.id, e)
                                  }
                                >
                                  {this._removeSessionButtonText(session)}
                                </button>
                              )}
                          </div>
                        </div>
                      </AccordionItem>
                    </Accordion>
                  ))}
              </div>

              {schedule.registeredPresentations.some(
                (presentation) => presentation.presentationDate === day
              ) && this.props.mobile === true ? (
                <div> </div>
              ) : (
                <>
                  {schedule.hasAvailablePresentations[index] && (
                    <div className="info-box sessions-available">
                      <div className="row">
                        <div className="col-lg-8">
                          {this.props.mobile === true ? (
                            <h2 className="blue-text">
                              No Sessions Selected for{" "}
                              <Moment format="dddd (M/D)">{day}</Moment>
                            </h2>
                          ) : (
                            <>
                              <h2 className="blue-text">
                                Sessions Available for{" "}
                                <Moment format="dddd (M/D)">{day}</Moment>
                              </h2>
                              <p>
                                You have space for more sessions. Sessions fill
                                up quickly!
                              </p>
                            </>
                          )}
                        </div>
                        <div className="col-lg-4">
                          {!this.props.mobile && (
                            <button
                              className="btn btn-view-sessions"
                              onClick={(e) =>
                                this._viewAvailableSessions(index)
                              }
                            >
                              View Available Sessions
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="divider"></div>
          </div>
        ))}
        {this._removeLinkedPresentationsModal()}
      </div>
    );
  }
}
